// icons
// import timeIcon from '@iconify/icons-carbon/time';
// @mui
import email from '@iconify/icons-carbon/email';
import phone from '@iconify/icons-carbon/phone';
import { Card, Link, Stack, Typography } from '@mui/material';
import { OfferProps } from 'src/@types/offer';
// components
import { Iconify, TextIconLabel } from '../../components';
import Image from '../../components/NextSanityImage';

// ----------------------------------------------------------------------

type Props = {
    offer: OfferProps
};

export default function OfferContactPerson({ offer }: Props) {
    const { contact } = offer;


    return (
        <Card sx={{ p: 3, borderRadius: 2 }}>
            <Stack spacing={3}>
                {contact.profile && (
                    <Image alt={contact.name + " kontaktperson"} src={contact.profile} ratio="1/1" sx={{ borderRadius: 2 }} />
                )}

                <Stack spacing={2}>
                    <Typography variant="overline" sx={{ color: 'text.secondary', mb: -1 }}>
                        Kontaktperson
                    </Typography>
                    <Typography variant="subtitle1">{contact.name}</Typography>
                    <TextIconLabel
                        icon={<Iconify icon={phone} sx={{ width: 20, height: 20, mr: 1 }} />}
                        value={<Link color="info" href={"tel:" + contact.phone}>{contact.phone}</Link>}
                    />
                    <TextIconLabel
                        icon={<Iconify icon={email} sx={{ width: 20, height: 20, mr: 1 }} />}
                        value={<Link color="info" href={"mailto:" + contact.email}>{contact.email}</Link>}
                    />
                </Stack>
            </Stack>
        </Card>
    );
}
